import { gsap } from 'gsap/dist/gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function () {
    const watermarks = gsap.utils.toArray('.c-wm');
    watermarks.forEach(watermark => {
        const watermarktrigger = watermark.parentElement;
        gsap.to(watermark, {
            xPercent: -2,
            yPercent: 60,
            scrollTrigger: {
                trigger: watermarktrigger,
                scrub: true
            }
        });
    });
}
